import { ISession } from './session';

export interface ISessionResponse {
    data: {
        success: boolean;
        results: ISession;
    }
}
